// @flow

import type {ApplicationState} from '../../types'
import {createSelector} from 'reselect'

import {getPagination} from './getPagination'

export function getPrevPage(appState: ApplicationState): ?Url{
  return _getPrevPage(appState.place)
}

const _getPrevPage = createSelector(
  [getPagination.internal],
  (pagination: ?PaginationResponse<PartnerPlace>) => {
    if (!pagination) return null
    return pagination._links.previous
  }
)

getPrevPage.internal = _getPrevPage
